import React from 'react';
import styled, { withTheme } from 'styled-components';

import { Button } from 'components/styled-primitives';

interface ToolbarButton {
  key: React.Key;
  props: React.ComponentProps<typeof Button>;
}

interface ActionToolbarProps {
  buttons?: (ToolbarButton | null | undefined)[];
}

const ActionToolbar = ({ buttons = [] }: ActionToolbarProps) => {
  const buttonLayout = buttons.map((button, index) => {
    if (button) {
      return (
        <ButtonWrapper key={button.key}>
          <Button {...button.props} />
        </ButtonWrapper>
      );
    }

    return <Spacer key={`spacer-${index}`} />;
  });
  return <ToolbarContainer>{buttonLayout}</ToolbarContainer>;
};

export default withTheme(ActionToolbar);

const ToolbarContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: ${({ theme }) => theme.grid.units(3)};
  padding: 0px 20px;
`;

const ButtonWrapper = styled.div`
  flex: 0 0 auto;
  padding-left: 20px;

  &:first-child {
    padding-left: 0px;
  }
`;

const Spacer = styled.div`
  flex: 0 1 145px;
  padding-left: 20px;
`;
